// English translations. Keys must mirror i18n.uz.ts exactly.

const en: Record<string, string> = {
  // ── A11y ───────────────────────────────────────────────────────────────
  "a11y.skip_to_content": "Skip to main content",
  "a11y.nav_primary": "Primary navigation",

  // ── Navigation ─────────────────────────────────────────────────────────
  "nav.home": "Home",
  "nav.gallery": "Templates",
  "nav.dashboard": "My invitation",
  "nav.help": "Help",
  "nav.cart": "Cart",
  "nav.signin": "Sign in",
  "nav.menu": "Menu",
  "nav.signout": "Sign out",
  "nav.pricing": "Pricing",

  // ── Common actions ────────────────────────────────────────────────────
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.preview": "Preview",
  "common.publish": "Publish",
  "common.loading": "Loading…",
  "common.back": "Back",
  "common.next": "Next",
  "common.continue": "Continue",
  "common.close": "Close",
  "common.open": "Open",
  "common.search": "Search",
  "common.send": "Send",
  "common.submit": "Submit",
  "common.confirm": "Confirm",
  "common.yes": "Yes",
  "common.no": "No",
  "common.error": "Something went wrong",
  "common.retry": "Try again",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.optional": "optional",
  "common.required": "required",

  // ── RSVP ──────────────────────────────────────────────────────────────
  "rsvp.title": "We hope to see you.",
  "rsvp.yes": "I'll be there",
  "rsvp.no": "I can't make it",
  "rsvp.maybe": "Not sure yet",
  "rsvp.name": "Your name",
  "rsvp.party_size": "How many guests?",
  "rsvp.message": "Message (optional)",
  "rsvp.submit": "Send response",
  "rsvp.thanks": "Thank you for your reply",

  // ── Sharing ───────────────────────────────────────────────────────────
  "share.title": "Share with loved ones",
  "share.copy": "Copy link",
  "share.copied": "Copied",
  "share.telegram": "Telegram",
  "share.whatsapp": "WhatsApp",
  "share.native": "Share",
  "share.qr": "QR code",

  // ── Calendar ──────────────────────────────────────────────────────────
  "calendar.add": "Add to calendar",
  "calendar.download": "Download ICS file",

  // ── Music ─────────────────────────────────────────────────────────────
  "music.title": "Choose music",
  "music.none": "No music",
  "music.play": "Play",
  "music.pause": "Pause",
  "music.premium": "Premium",

  // ── Editor ────────────────────────────────────────────────────────────
  "editor.title": "Edit invitation",
  "editor.names": "Names",
  "editor.date": "Date",
  "editor.time": "Time",
  "editor.venue": "Venue",
  "editor.address": "Address",
  "editor.map_url": "Map link",
  "editor.story": "Our story",
  "editor.photos": "Photos",
  "editor.schedule": "Schedule",

  // ── Auth ──────────────────────────────────────────────────────────────
  "auth.email": "Email",
  "auth.code": "Verification code",
  "auth.send_code": "Send code",
  "auth.verify": "Verify",
  "auth.welcome": "Welcome",

  // ── Errors ────────────────────────────────────────────────────────────
  "error.network": "Network problem",
  "error.notfound": "Not found",
  "error.forbidden": "Forbidden",

  // ── Landing hero ──────────────────────────────────────────────────────
  "landing.hero.eyebrow": "N°01 — Digital invitations",
  "landing.hero.headline_1": "Every celebration",
  "landing.hero.headline_2": "deserves its own",
  "landing.hero.headline_3": "story.",
  "landing.hero.body": "Modern, refined digital invitations for weddings, nikoh, beshik toy and every other day that matters. Ready in minutes — remembered for a lifetime.",
  "landing.hero.trust": "Every template is an original design, crafted by a designer",
  "landing.cta.browse": "Browse templates →",
  "landing.cta.how": "How it works",
  "landing.hero.handcrafted": "handcrafted",

  // ── Landing stats ─────────────────────────────────────────────────────
  "landing.stats.templates": "templates",
  "landing.stats.setup": "to set up",
  "landing.stats.sent": "sent",
  "landing.stats.languages": "languages",
  "landing.stats.coming": "templates incoming",
  "landing.stats.setup_value": "12 min",

  // ── Landing marquee ───────────────────────────────────────────────────
  "landing.marquee.wedding": "Wedding",
  "landing.marquee.nikoh": "Nikoh",
  "landing.marquee.beshik": "Beshik toy",
  "landing.marquee.birthday": "Birthday",
  "landing.marquee.jubilee": "Anniversary",
  "landing.marquee.corporate": "Corporate",
  "landing.marquee.memorial": "Memorial",

  // ── Landing trending (N°02) ───────────────────────────────────────────
  "landing.trending.eyebrow": "N°02 — New arrivals",
  "landing.trending.headline_1": "Just",
  "landing.trending.headline_2": "added",

  // ── Landing categories ────────────────────────────────────────────────
  "landing.categories.eyebrow": "N°03 — Templates",
  "landing.categories.headline_1": "For every",
  "landing.categories.headline_2": "celebration",
  "landing.categories.headline_3": "you can imagine.",
  "landing.categories.see_all": "See all",

  // ── Landing featured ──────────────────────────────────────────────────
  "landing.featured.eyebrow": "N°04 · SELECTION",
  "landing.featured.headline_1": "The season's",
  "landing.featured.headline_2": "most loved",
  "landing.featured.headline_3": "templates.",

  // ── Landing how it works ──────────────────────────────────────────────
  "landing.how.eyebrow": "N°05 — How it works",
  "landing.how.headline_1": "Four steps — and",
  "landing.how.headline_2": "your invitation is ready.",
  "landing.how.step1.title": "Choose",
  "landing.how.step1.desc": "Pick a favourite from 240+ templates.",
  "landing.how.step2.title": "Personalise",
  "landing.how.step2.desc": "Update names, date, venue and the wording.",
  "landing.how.step3.title": "Pay",
  "landing.how.step3.desc": "Pay with Payme, Click, Uzcard or Humo.",
  "landing.how.step4.title": "Share",
  "landing.how.step4.desc": "Send the link to your guests.",

  // ── Landing testimonial ───────────────────────────────────────────────
  "landing.testimonial.eyebrow": "N°06 — From our guests",
  "landing.testimonial.quote": "\"The most beautiful invitation for our wedding. Our guests kept asking 'is it really not on paper?' — that's how elegant it felt.\"",
  "landing.testimonial.location": "Tashkent · 2026",
  "landing.testimonial.ratings": "3,200+ reviews",
  "landing.testimonial.recommend": "would recommend",

  // ── Landing final CTA ─────────────────────────────────────────────────
  "landing.final.headline_1": "Let's begin your",
  "landing.final.headline_2": "celebration.",
  "landing.final.body": "Pick a template today and delight your guests tomorrow.",

  // ── Footer ────────────────────────────────────────────────────────────
  "footer.tagline": "Uzbekistan's most beautiful digital invitations. For every moment that matters.",
  "footer.col.discover": "Discover",
  "footer.col.discover.all": "All templates",
  "footer.col.discover.wedding": "Wedding invitations",
  "footer.col.discover.nikoh": "Nikoh",
  "footer.col.discover.birthday": "Birthday",
  "footer.col.discover.beshik": "Beshik toy",
  "footer.col.company": "Company",
  "footer.col.company.about": "About us",
  "footer.col.company.designers": "Designers",
  "footer.col.company.privacy": "Privacy",
  "footer.col.company.terms": "Terms",
  "footer.col.company.contact": "Contact",
  "footer.col.payment": "Payment",
  "footer.copyright": "© 2026 Taklifla.uz",
  "footer.made": "Made with care in Tashkent · ✦",
  "support.aria": "Help",
  "support.note": "Hit a problem? Reach us on Telegram:",
  "inapp.aria": "Browser notice",
  "inapp.body": "Some features may not work fully here. Feel free to open the site in your default browser.",
  "inapp.open_browser": "Open in browser ↗",
  "inapp.copy": "Copy link",
  "inapp.copied": "Copied ✓",
  "inapp.copy_fallback": "Select and copy this link:",
  "inapp.ios_hint": "iOS: tap the ⋯ menu and choose \"Open in browser\".",
  "inapp.dismiss": "Dismiss",
  "auth.telegram.hint": "Telegram will bring you back after you confirm. If it doesn't return you, refresh this page or use email below.",
  "auth.inapp.handoff_hint": "Tapping Telegram will hand you off to your default browser.",
  "auth.inapp.google_resume": "Tap the Google button below to continue.",
  "editor.lock.identity.pre_publish": "Heads up: names and date can be edited only for 48 hours after publishing. After that they're locked — one purchase can't be reused for a different couple.",
  "editor.lock.identity.grace": "Names and date are still editable — they lock in {remaining}.",
  "editor.lock.identity.locked": "Names and date are locked: 48 hours have passed since publish. Venue, schedule, music, info card and the rest stay editable. If you genuinely need to change them, reach out to support.",
  "editor.lock.slug.pre_publish": "Heads up: after publishing the URL can be changed at most 3 times within the first 7 days. After that it's frozen.",
  "editor.lock.slug.remaining": "You can still change the URL {n} more time(s) within 7 days of publish.",
  "editor.lock.slug.frozen": "URL is frozen: 3 changes used or 7 days have passed since publish. The URL can no longer be changed.",
  "editor.error.identity_locked": "Names and date are locked 48 hours after publish. They can no longer be edited.",
  "editor.error.slug_frozen": "The URL is frozen and can no longer be changed.",
  "auth.already_signed_in": "You're already signed in.",
  "auth.go_to_dashboard": "Go to dashboard",

  // ── Categories (template list) ────────────────────────────────────────
  "category.all": "All",
  "category.bookie": "Bookie",
  "category.wedding": "Wedding",
  "category.nikoh": "Nikoh",
  "category.birthday": "Birthday",
  "category.beshik": "Baby shower",
  "category.corporate": "Corporate",
  "category.memorial": "Memorial",
  "category.yubiley": "Anniversary",
  "category.fotixa": "Engagement",
  "category.sunnat": "Sunnat to'y",
  "category.graduation": "Graduation",
  "category.uy": "Housewarming",
  "category.sevgi": "Valentine's Day",
  "category.iftor": "Iftar",

  // ── Tier labels ───────────────────────────────────────────────────────
  "tier.bestseller": "Bestseller",
  "tier.premium": "Premium",
  "tier.new": "New",
  "tier.standard": "Standard",

  // ── Common (extras) ───────────────────────────────────────────────────
  "common.coming_soon": "Coming soon",

  // ── Gallery ───────────────────────────────────────────────────────────
  "gallery.eyebrow": "Collection",
  "gallery.headline_1": "All",
  "gallery.headline_2": "templates",
  "gallery.count": "{count} templates",
  "gallery.sort.popular": "Popular",
  "gallery.sort.price_asc": "Cheap → Expensive",
  "gallery.sort.price_desc": "Expensive → Cheap",
  "gallery.sort.label": "Sort",
  "gallery.sort.newest": "Newest",
  "gallery.categories.more": "More",
  "gallery.categories.allLabel": "All categories",
  "gallery.close": "Close",
  "gallery.empty": "Nothing found",

  // ── Template detail ───────────────────────────────────────────────────
  "detail.device.site": "Site",
  "detail.device.card": "Card",
  "detail.device.phone": "Phone",
  "detail.fullscreen": "Open in full screen →",
  "detail.preview_caption": "Live preview · scroll to see more",
  "detail.premium_caption": "✦ Premium quality",
  "detail.description": "A complete invitation site. Names, date, venue, photo gallery, RSVP, music, guestbook — all in one link.",
  "detail.price_caption": "One-time payment · unlimited guests",
  "detail.owned_cta": "Open my invitation",
  "detail.customize": "Personalize",
  "detail.feature.guests.title": "Unlimited guests",
  "detail.feature.guests.caption": "No cap",
  "detail.feature.rsvp.title": "Collect RSVPs",
  "detail.feature.rsvp.caption": "Replies and stats",
  "detail.feature.link.title": "Personal link",
  "detail.feature.link.caption": "taklifla.uz/your-name",
  "detail.feature.gallery.title": "Photo gallery",
  "detail.feature.gallery.caption": "Up to 10 photos",
  "detail.feature.music.title": "Music",
  "detail.feature.music.caption": "Background audio",
  "detail.feature.guestbook.title": "Guestbook",
  "detail.feature.guestbook.caption": "Wishes from guests",
  "detail.buy": "Buy · {price}",
  "detail.preparing": "Preparing…",
  "detail.favorite": "Add to favorites",
  "detail.buy_error_fallback": "Something went wrong. Please try again.",
  "detail.payment_methods": "Payme · Click · Uzcard · Humo · Visa · Mastercard",
  "detail.related.title_1": "You might",
  "detail.related.title_2": "also",
  "detail.related.title_3": "like",
  "detail.related.all": "View all",

  // ── Checkout ──────────────────────────────────────────────────────────
  "checkout.breadcrumb.dashboard": "Dashboard",
  "checkout.breadcrumb.payment": "Payment",
  "checkout.summary.eyebrow": "Order details",
  "checkout.summary.title": "Your invitation",
  "checkout.subtotal": "Subtotal",
  "checkout.promo": "Promo",
  "checkout.total": "Total",
  "checkout.cancel": "← Cancel and return to dashboard",
  "checkout.payment.eyebrow": "Payment method",
  "checkout.payment.title": "Pick what works for you",
  "checkout.payment.payme.label": "Payme",
  "checkout.payment.payme.sublabel": "Most popular payment system",
  "checkout.payment.click.label": "Click",
  "checkout.payment.click.sublabel": "Card payment",
  "checkout.payment.uzcard.label": "Uzcard / Visa",
  "checkout.payment.uzcard.sublabel": "Bank cards",
  "checkout.promo.label": "Promo code",
  "checkout.promo.placeholder": "e.g. TAKLIF10",
  "checkout.promo.apply": "Apply",
  "checkout.promo.unavailable": "Promo codes coming soon",
  "checkout.pay": "Pay · {total}",
  "checkout.payment_unavailable": "Payment systems not connected yet — coming soon",
  // Payme branding strings.
  "checkout.payWith": "Pay with · Payme",
  "checkout.secure": "Secure payment via Payme",
  "checkout.poweredBy": "Derio Technologies LLC",
  // Shared payment-state strings.
  "checkout.already_paid": "This invitation is already unlocked.",
  "checkout.go_editor": "Go to editor →",
  "checkout.coming_soon.title": "Payments coming soon",
  "checkout.coming_soon.body": "Payme/Click integration is not enabled in this environment yet. Please try again later.",
  "checkout.pay.body": "Pay securely with Payme. Your invitation activates the moment the payment clears.",
  "checkout.pay.payme": "Pay with Payme · {total}",
  "checkout.pay.click": "Pay with Click · {total}",
  "checkout.pay.redirecting": "Redirecting to gateway…",
  "checkout.pay.disclaimer": "Your invitation activates the moment the payment clears.",
  "checkout.pay.error_generic": "Could not start payment. Please try again.",
  "payment.return.missing.title": "Missing payment details",
  "payment.return.missing.body": "We couldn't find an order id. Please restart the payment from your invitation page.",
  "payment.return.go_dashboard": "Back to dashboard",
  "payment.return.polling.title": "Confirming payment",
  "payment.return.polling.body": "Waiting for the payment provider. This usually takes a few seconds.",
  "payment.return.polling.hint": "Don't close this page.",
  "payment.return.paid.title": "Payment successful!",
  "payment.return.paid.body": "Your invitation is now active — you can edit it and share with guests.",
  "payment.return.paid.cta_editor": "Open editor",
  "payment.return.cancelled.title": "Payment cancelled",
  "payment.return.cancelled.body": "No money was charged. You can try again whenever you like.",
  "payment.return.cancelled.try_again": "Try again",
  "payment.return.failed.title": "Payment didn't go through",
  "payment.return.failed.body": "The provider declined the transaction. Try a different card or method.",
  "payment.return.timeout.title": "Still waiting",
  "payment.return.timeout.body": "The provider hasn't responded yet. Check back in a few minutes — if the funds were taken, your invitation will activate automatically.",
  "payment.return.timeout.retry": "Check again",
  "payment.return.error.title": "Something went wrong",
  "payment.return.error.not_found": "Order not found.",
  "checkout.trust": "Secure payment · 256-bit SSL · Payme and Click official partner",
  "checkout.notfound.eyebrow": "Invitation not found",
  "checkout.notfound.title": "No such order",
  "checkout.notfound.body": "Check the link or create a new invitation from the templates section.",
  "checkout.notfound.cta": "Browse templates",
  "checkout.notfound.cta_dashboard": "Dashboard",
  "checkout.error.title": "Error",
  "checkout.error.fallback": "Couldn't load invitation",
  "checkout.error.back": "Back to dashboard",
  "checkout.promise.free": "Unlimited guests · live for 7 days",
  "checkout.promise.premium": "Forever live · no watermark · priority support",
  "checkout.payment.coming_soon": "Coming soon",
  "checkout.breadcrumb.home": "Home",

  // ── Detail page extras ───────────────────────────────────────────────
  "detail.breadcrumb.home": "Home",
  "detail.breadcrumb.gallery": "Templates",

  // ── Gallery page extras ──────────────────────────────────────────────
  "gallery.search.placeholder": "Search...",

  // ── Sections ─────────────────────────────────────────────────────────
  "sections.countdown.eyebrow": "COUNTDOWN",
  "sections.countdown.day": "DAYS",
  "sections.countdown.hour": "HOURS",
  "sections.countdown.minute": "MINUTES",
  "sections.countdown.second": "SECONDS",
  "sections.countdown.passed": "EVENT HAS PASSED",
  "sections.schedule.eyebrow": "SCHEDULE",
  "sections.schedule.title": "Throughout the day",
  "sections.rsvp.eyebrow": "RSVP",
  "sections.map.eyebrow": "ADDRESS",
  "sections.map.title": "Find us",
  "sections.map.open": "Open in Yandex Maps →",
  "sections.map.loading": "MAP LOADING…",
  "sections.gallery.eyebrow": "PHOTO ALBUM",
  "sections.gallery.title": "Our moments",
  "sections.guestbook.title": "Leave a wish",
  "sections.guestbook.placeholder": "Write your congratulations...",
  "sections.guestbook.name_placeholder": "Your name",
  "sections.guestbook.send": "Send →",
  "sections.guestbook.sending": "Sending…",
  "sections.guestbook.ok": "✓ Your wish was received",
  "sections.guestbook.err": "Couldn't send — please try again",
  "sections.guestbook.closed.eyebrow": "BOOK CLOSED",
  "sections.guestbook.closed.title": "The day has passed — thank you",
  "sections.guestbook.closed.body": "New wishes are no longer accepted. The words guests left behind will stay as a keepsake of the day.",
  "sections.guestbook.closed.count": "{count} wishes were left",
  "sections.footer.signature": "MADE WITH TAKLIFLA.UZ",
  "sections.lightbox.close": "Close",

  // ── Dashboard ────────────────────────────────────────────────────────
  "dashboard.eyebrow": "Dashboard",
  "dashboard.greeting": "Hello, {name}",
  "dashboard.subtitle": "Your invitations and their status are right here.",
  "dashboard.new": "New invitation +",
  "dashboard.empty.title": "No invitations yet",
  "dashboard.empty.body": "Head to the templates gallery to create your first invitation.",
  "dashboard.empty.cta": "Browse templates →",
  "dashboard.error.eyebrow": "Error",
  "dashboard.error.body": "Couldn't load invitations: {message}",
  "dashboard.error.unknown": "unknown error",
  "dashboard.retry": "Try again ↻",
  "dashboard.signin.title": "My invitation",
  "dashboard.signin.body": "Sign in first to manage your invitations.",
  "dashboard.signin.cta": "Sign in →",
  "dashboard.account": "Account",
  "dashboard.guest": "Guest",
  "dashboard.unnamed": "Untitled invitation",
  "dashboard.no_date_venue": "Date and venue not set",
  "dashboard.status.published": "Live",
  "dashboard.status.expired": "Expired",
  "dashboard.status.draft": "Draft",
  "dashboard.action.edit": "Edit",
  "dashboard.action.view": "View ↗",
  "dashboard.action.publish": "Publish →",
  "dashboard.action.publishing": "Publishing…",
  "dashboard.menu.more": "More",
  "dashboard.menu.publish": "Publish",
  "dashboard.menu.copy_link": "Copy link",
  "dashboard.menu.open_new": "Open in new tab",
  "dashboard.menu.delete": "Delete",
  "dashboard.menu.unpublish": "Make private",
  "dashboard.copy.copied": "✓ Copied",
  "dashboard.copy.action": "copy",
  "dashboard.copy.fallback_prompt": "Copy the link:",
  "dashboard.copy.aria": "Copy link",
  "dashboard.confirm_delete": "Really delete \"{name}\"?\n\nThis cannot be undone.",
  "dashboard.confirm_delete.fallback": "This invitation",
  "dashboard.confirm_unpublish": "Make \"{name}\" private?\n\nThe public link will stop opening, but the invitation and all wishes are kept — you can publish it again anytime.",
  "dashboard.publish.success": "Invitation is live! Link: {url}",
  "dashboard.unpublish.success": "Invitation is now private. You can publish it again anytime.",
  "dashboard.thumb_aria": "{name} — edit",
  "dashboard.thumb_fallback": "Invitation",

  // ── Editor ───────────────────────────────────────────────────────────
  "editor.eyebrow.create": "New invitation",
  "editor.eyebrow.edit": "Edit",
  "editor.cancel": "← Cancel",
  "editor.cancel_short": "Cancel",
  "editor.title.create_1": "New",
  "editor.title.create_2": "invitation",
  "editor.title.edit_1": "Edit",
  "editor.title.edit_2": "invitation",
  "editor.template_label": "Template",
  "editor.status_label": "Status",
  "editor.field.names.placeholder": "Aziza & Sardor",
  "editor.field.names.error_min": "Enter at least 3 characters",
  "editor.field.time.placeholder": "17:00",
  "editor.field.venue.placeholder": "Tashkent",
  "editor.field.address.placeholder": "Restaurant name and full address",
  "editor.field.map_url.placeholder": "https://maps.app.goo.gl/...",
  "editor.field.map_url.helper": "Optional. Paste a Google Maps, Apple Maps, or Yandex link — the \"Map\" button on your invitation opens this exact URL.",
  "editor.field.slug.label": "URL",
  "editor.field.slug.placeholder": "aziza-sardor",
  "editor.field.slug.auto": "Auto",
  "editor.field.slug.error_format": "Only lowercase letters, digits, and '-'",
  "editor.field.slug.helper": "Guest link: taklifla.uz/i/{slug}",
  "editor.field.slug.helper_empty": "...",
  "editor.field.story.label": "Our story",
  "editor.field.story.placeholder": "A few words about how you met…",
  "editor.field.date.calendar": "calendar",
  "editor.field.date.text": "type manually",
  "editor.field.date.placeholder": "12.06.2026",
  "editor.field.date.error": "Format: dd.mm.yyyy (e.g. 12.06.2026)",
  "editor.field.photos.label": "Photos",
  "editor.field.photos.placeholder": "Coming soon — photo upload",
  "editor.field.music.label": "Music",
  "editor.field.music.placeholder": "Coming soon — music selection",
  "editor.field.schedule.label": "Schedule",
  "editor.field.schedule.empty": "No schedule items yet",
  "editor.field.schedule.event_placeholder": "Welcoming guests",
  "editor.field.schedule.delete": "Delete",
  "editor.field.schedule.add": "+ Add",
  // ── Feature-driven editor blocks ─────────────────────────────────────
  "editor.feat.gallery": "Photos",
  "editor.feat.gallery.helper": "Upload your 3–10 best photos. The first one becomes the cover.",
  "editor.feat.schedule": "Event programme",
  "editor.feat.agenda": "Agenda",
  "editor.feat.timeline": "Key dates",
  "editor.feat.timeline.ph_a": "Year",
  "editor.feat.timeline.ph_b": "Event",
  "editor.feat.speakers": "Speakers",
  "editor.feat.speakers.ph_a": "Full name",
  "editor.feat.speakers.ph_b": "Role",
  "editor.feat.wishlist": "Gift list",
  "editor.feat.wishlist.helper": "Gift ideas for guests, or a link.",
  "editor.feat.dresscode": "Dress code",
  "editor.feat.dresscode.helper": "e.g. formal, black & white, national dress",
  "editor.feat.quran": "Verse / prayer",
  "editor.feat.quran.ph": "Enter the verse or prayer to be read at the ceremony…",
  "editor.feat.bio": "Biography",
  "editor.feat.bio.ph": "A few words about the departed — years of life, their path…",
  "editor.feat.story.love": "Your love story",
  "editor.feat.story.love.ph": "How you met, how you decided — a short story…",
  "editor.feat.story.person": "About the celebrant",
  "editor.feat.story.person.ph": "A few warm words about the guest of honour…",
  "editor.feat.story.child": "About the joyful day",
  "editor.feat.story.child.ph": "About your child and this joyful day…",
  "editor.feat.story.memorial": "Words of remembrance",
  "editor.feat.story.memorial.ph": "Memories and warm words about the departed…",
  "editor.feat.story.event": "About the event",
  "editor.feat.story.event.ph": "A brief note about this event…",
  "editor.list.add": "+ Add",
  "editor.list.empty": "Nothing added yet",
  "editor.list.remove": "Remove",
  "editor.save": "Save",
  "editor.saving": "Saving…",
  "editor.publish": "Publish →",
  "editor.publish_short": "Publish",
  "editor.publishing": "Publishing…",
  "editor.publish_disabled.not_draft": "Only draft invitations can be published",
  "editor.publish_disabled.fields": "Fill in all required fields",
  "editor.error.save": "Couldn't save",
  "editor.error.publish": "Couldn't publish",
  "editor.error.names_min": "Names must be at least 3 characters",
  "editor.error.slug_format": "Invalid slug format. Only a-z, 0-9 and '-' allowed.",
  "editor.error.required_fields": "Fill in all required fields before publishing",
  "editor.toast.saved": "Saved",
  "editor.toast.published": "Invitation is live",
  "editor.share.eyebrow": "Published · ready to share",
  "editor.share.title": "Your invitation is live",
  "editor.share.body": "Send this link to your guests — each invitation gets its own unique URL.",
  "editor.share.copy": "Copy link",
  "editor.share.copied": "✓ Copied",
  "editor.share.copy_fallback": "Select and copy",
  "editor.share.whatsapp": "WhatsApp",
  "editor.share.telegram": "Telegram",
  "editor.share.open": "Open ↗",
  "editor.share.message": "You're invited to our celebration",
  "editor.share.expires": "Free tier expires:",
  "editor.wishes.eyebrow": "Guest wishes",
  "editor.wishes.title": "Moderate wishes",
  "editor.wishes.body": "Every wish guests have left is here. Delete anything you'd rather not keep.",
  "editor.wishes.count_suffix": "wishes",
  "editor.wishes.loading": "Loading…",
  "editor.wishes.error": "Couldn't load wishes",
  "editor.wishes.empty": "No wishes yet. The first guest's note will show up here.",
  "editor.wishes.delete": "Delete",
  "editor.wishes.deleting": "Deleting…",
  "editor.wishes.confirm_delete": "Delete this wish?",
  "editor.wishes.refresh": "Refresh",
  "help.eyebrow": "Help center",
  "help.title_1": "Frequently asked",
  "help.title_2": "questions",
  "help.lede": "Answers to the main questions about using Taklifla.uz. Can't find yours? Send us a message on Telegram — we reply within a day.",
  "help.faq.buy.q": "How do I buy an invitation?",
  "help.faq.buy.a": "Pick a design from the Templates page, hit \"Buy\" and pay through Payme. The invitation unlocks in your account as soon as the payment clears.",
  "help.faq.edit.q": "Where do I edit the text after I buy?",
  "help.faq.edit.a": "Your dashboard (\"My invitations\") lists every invitation you've bought. Each one has an \"Edit\" button — change names, date, venue and music there.",
  "help.faq.share.q": "How do I send the link to my guests?",
  "help.faq.share.a": "After saving and hitting \"Publish\", a share panel appears at the top: copy link, WhatsApp or Telegram — one click each.",
  "help.faq.expiry.q": "How long does the invitation stay online?",
  "help.faq.expiry.a": "On the free tier, 7 days from publish. The premium tier will lift that — once payment is connected.",
  "help.faq.lifetime.q": "How long does a purchased invitation stay live?",
  "help.faq.lifetime.a": "A purchased invitation stays active for as long as the taklifla.uz service runs — possibly a lifetime. If the project shuts down, the site stops, or our company ceases operating, we cannot guarantee invitations will remain online.",
  "help.faq.refund.q": "Can I get a refund?",
  "help.faq.refund.a": "The service is free right now — no payments means no refunds yet. We'll publish a refund policy when real payment goes live.",
  "help.contact.eyebrow": "Contact",
  "help.contact.title": "Still have a question?",
  "help.contact.body": "Drop us a line on Telegram — we reply within a day. Or send an email.",
  "help.contact.telegram": "Telegram",
  "help.contact.email": "Email",
  "help.contact.dashboard": "Go to dashboard →",
  "editor.preview.title": "Live preview",
  "editor.preview.open_new": "Open in new tab ↗",
  "editor.preview.empty": "Appears after saving",
  "editor.notfound.title": "Not found",
  "editor.notfound.body": "This invitation doesn't exist or isn't yours.",
  "editor.notfound.back": "← Back to dashboard",
  "editor.no_template.title": "No template selected",
  "editor.no_template.body": "Pick a template from the gallery first.",
  "editor.no_template.back": "← Back to gallery",

  // ── Login ────────────────────────────────────────────────────────────
  "login.title": "Sign in",
  "login.label.email": "Email",
  "login.placeholder.email": "you@email.uz",
  "login.placeholder.code": "123456",
  "login.send_code": "Send code",
  "login.sending": "Sending…",
  "login.code_sent": "We sent a 6-digit code to {target}.",
  "login.verify": "Verify",
  "login.verifying": "Verifying…",
  "login.back": "Back",
  "login.error.send": "Couldn't send",
  "login.error.code": "Wrong code",

  // Sign in with Google
  "auth.google.button": "Sign in with Google",
  "auth.google.divider": "or",
  "auth.google.error.unverified": "Google reports this account's email as unverified.",
  "auth.google.error.failed": "Sign in with Google failed. Please try again.",
  "auth.google.error.disabled": "Sign in with Google is currently disabled.",

  // Sign in with Telegram — OIDC + PKCE. Button rendered locally (no
  // official drop-in for the OIDC flow).
  "auth.telegram.button": "Sign in with Telegram",
  "auth.telegram.signing_in": "Verifying with Telegram…",
  "auth.telegram.error.title": "Sign-in error",
  "auth.telegram.error.back_to_login": "Back to sign-in",
  "auth.telegram.error.start": "Couldn't reach Telegram. Please try again.",
  "auth.telegram.error.from_telegram": "Telegram returned: {detail}",
  "auth.telegram.error.missing_code": "Telegram didn't return an authorization code. Please try again.",
  "auth.telegram.error.no_state": "Sign-in session not found. Please start again.",
  "auth.telegram.error.stale": "Sign-in session expired. Please try again.",
  "auth.telegram.error.state_mismatch": "Security check failed. Please try again.",
  "auth.telegram.error.exchange": "Couldn't exchange the Telegram token. Please try again.",
  "auth.telegram.error.disabled": "Sign in with Telegram is currently disabled.",

  "auth.verify.success": "Verified",

  // ── 404 ──────────────────────────────────────────────────────────────
  "notfound.eyebrow": "Page not found",
  "notfound.title": "Page not found",
  "notfound.body": "This page doesn't exist yet or was removed. Head back to the homepage or browse the templates.",
  "notfound.home": "Back to home",
  "notfound.gallery": "Browse templates",

  // ── Guest page ───────────────────────────────────────────────────────
  "guest.loading": "Loading…",
  "guest.notfound.title": "Invitation not found",
  "guest.notfound.body": "This link is outdated or wrong.",
  "guest.error.title": "Something went wrong",
  "guest.cta.respond": "RSVP →",
  "guest.cta.coming": "✓ I'll be there",
  "guest.cta.declined": "I can't make it",
  "guest.music.play_aria": "Play music",
  "guest.music.pause_aria": "Pause music",
  "guest.music.now_playing": "Now playing",
  "guest.music.tap_to_play": "Tap to play",

  // ── PhotoUploader ────────────────────────────────────────────────────
  "photo.count": "{n} / {max} photos",
  "photo.add": "+ Add photo",
  "photo.add_aria": "Add photo",
  "photo.pick_aria": "Pick photo",
  "photo.zone.title": "Drop a photo or click to pick",
  "photo.zone.caption": "JPG, PNG, WEBP — up to 10 MB",
  "photo.zone.slots": "{n} slots left",
  "photo.zone.aria": "Drop or click to pick a photo",
  "photo.alt": "Photo {n}",
  "photo.delete_aria": "Delete photo {n}",
  "photo.uploading_alt": "Uploading",
  "photo.uploading_aria": "Uploading",
  "photo.error_fallback": "Error",
  "photo.retry": "Retry",
  "photo.retry_aria": "Retry",
  "photo.cancel_aria": "Cancel",
  "photo.error.mime": "\"{name}\" — only JPG, PNG or WEBP allowed",
  "photo.error.size": "\"{name}\" — over 10 MB, can't upload",
  "photo.error.max": "Up to {max} photos can be uploaded",
  "photo.error.network": "Network error",

  // ── MusicSelector ────────────────────────────────────────────────────
  "music.section_label": "Music",
  "music.none.subtitle": "Opens in silence",
  "music.loading": "Loading…",
  "music.fallback_notice": "Catalog temporarily unavailable — showing a sample list.",
  "music.preview.play_aria": "Play preview",
  "music.preview.pause_aria": "Pause preview",

  // ── RSVP section extras ──────────────────────────────────────────────
  "sections.rsvp.thanks": "Thanks! Your reply was received",
  "sections.rsvp.err": "Couldn't send — please try again",
  "sections.rsvp.your_name": "Your name",
  "sections.rsvp.deadline": "Please reply by {day} {month}.",
  "sections.rsvp.thanks_short": "Thank you!",
  "sections.rsvp.guest_count": "Guests:",
  "sections.rsvp.regret_title": "We'll miss you...",
  "sections.rsvp.regret_body": "We'll be thinking of you. Thank you for the kind wishes.",
  "sections.rsvp.month.1": "Jan",
  "sections.rsvp.month.2": "Feb",
  "sections.rsvp.month.3": "Mar",
  "sections.rsvp.month.4": "Apr",
  "sections.rsvp.month.5": "May",
  "sections.rsvp.month.6": "Jun",
  "sections.rsvp.month.7": "Jul",
  "sections.rsvp.month.8": "Aug",
  "sections.rsvp.month.9": "Sep",
  "sections.rsvp.month.10": "Oct",
  "sections.rsvp.month.11": "Nov",
  "sections.rsvp.month.12": "Dec",
  "sections.ics.suffix.wedding": " — Wedding",
  "sections.ics.suffix.birthday": " — Celebration",
  "sections.ics.description.wedding": "We hope to see you at our wedding",
  "sections.ics.description.default": "We hope to see you at the celebration",

  // ── variant.w01 (Asal — Editorial) ─────────────────────────────────────
  "variant.w01.hero.eyebrow": "NIKOH CEREMONY",
  "variant.w01.hero.and": "and",
  "variant.w01.hero.body": "\"We invite you to share the most important day of our lives with us.\"",
  "variant.w01.hero.love_tag": "from us, with love",
  "variant.w01.hero.caption_label": "ROYAL PALACE",
  "variant.w01.story.eyebrow": "our story",
  "variant.w01.story.title": "Our story",
  "variant.w01.story.body": "Six years ago we met by chance in the university library. That very day we joked about how late we would get home. Today, with the intention of spending our whole lives together, we invite you to our happiest day.",
  "variant.w01.quote.text": "\"There are many in love, but few are true lovers.\"",
  "variant.w01.quote.author": "— ALISHER NAVOIY",
  "variant.w01.bridal.eyebrow": "BRIDAL PARTY",
  "variant.w01.bridal.title": "Standing beside us",
  "variant.w01.bridal.groom_label": "Groom's side",
  "variant.w01.bridal.groom_list": "Sardor (brother) · Bobur · Akmal",
  "variant.w01.bridal.bride_label": "Bride's side",
  "variant.w01.bridal.bride_list": "Madina (sister) · Nilufar · Sevara",
  "variant.w01.schedule.0.time": "16:30",
  "variant.w01.schedule.0.event": "Welcoming guests",
  "variant.w01.schedule.1.time": "17:00",
  "variant.w01.schedule.1.event": "Nikoh ceremony",
  "variant.w01.schedule.2.time": "18:00",
  "variant.w01.schedule.2.event": "Formal dinner",
  "variant.w01.schedule.3.time": "20:00",
  "variant.w01.schedule.3.event": "Dancing and music",
  "variant.w01.schedule.4.time": "23:00",
  "variant.w01.schedule.4.event": "Send-off",
  "variant.w01.map.address": "\"Royal Palace\" wedding hall · Yunusobod block 12",

  // ── variant.w04 (Tilla — Magazine) ─────────────────────────────────────
  "variant.w04.cover.lead": "The Wedding of",
  "variant.w04.cover.featured": "FEATURED",
  "variant.w04.cover.exclusive": "EXCLUSIVE EDITION",
  "variant.w04.cover.edition": "EDITION 01 / 99",
  "variant.w04.cover.vol": "VOL. I · NO. 1",
  "variant.w04.cover.meta_date": "DATE",
  "variant.w04.cover.meta_time": "TIME",
  "variant.w04.cover.meta_venue": "VENUE",
  "variant.w04.spread.feature_no": "FEATURE · 04",
  "variant.w04.spread.title": "The Spread",
  "variant.w04.spread.pages": "PG. 12—15",
  "variant.w04.spread.shot1": "SHOT 01",
  "variant.w04.quote.text": "Love is the force that guides two hearts toward one purpose.",
  "variant.w04.timeline.eyebrow": "OUR JOURNEY",
  "variant.w04.timeline.title": "A chronicle of love",
  "variant.w04.timeline.chapter": "CHAPTER",
  "variant.w04.timeline.0.event": "First meeting",
  "variant.w04.timeline.0.sub": "A chance encounter at the university library",
  "variant.w04.timeline.1.event": "First trip",
  "variant.w04.timeline.1.sub": "A journey to Samarkand together",
  "variant.w04.timeline.2.event": "The proposal",
  "variant.w04.timeline.2.sub": "\"Yes\" on the shore of Charvak",
  "variant.w04.timeline.3.event": "The wedding",
  "variant.w04.timeline.3.sub": "Today's blessed day",
  "variant.w04.schedule.0.time": "17:00",
  "variant.w04.schedule.0.event": "Welcoming guests",
  "variant.w04.schedule.1.time": "18:00",
  "variant.w04.schedule.1.event": "Nikoh ceremony",
  "variant.w04.schedule.2.time": "19:00",
  "variant.w04.schedule.2.event": "Galaxy Hall · Dinner",
  "variant.w04.schedule.3.time": "21:00",
  "variant.w04.schedule.3.event": "Formal dancing",
  "variant.w04.schedule.4.time": "23:00",
  "variant.w04.schedule.4.event": "Fireworks show",
  "variant.w04.dress.eyebrow": "DRESS CODE",
  "variant.w04.dress.title": "Black Tie & Gold",
  "variant.w04.dress.blurb": "Formal evening attire for the ceremony. Tuxedos or dark suits for gentlemen, long gowns for ladies.",
  "variant.w04.dress.preferred_for": "PREFERRED ATTIRE FOR {name}",
  "variant.w04.dress.swatch.0.name": "Black",
  "variant.w04.dress.swatch.0.role": "Tuxedo",
  "variant.w04.dress.swatch.1.name": "Gold",
  "variant.w04.dress.swatch.1.role": "Accessory",
  "variant.w04.dress.swatch.2.name": "Cream",
  "variant.w04.dress.swatch.2.role": "Shirt",
  "variant.w04.dress.swatch.3.name": "Burgundy",
  "variant.w04.dress.swatch.3.role": "Tie",
  "variant.w04.map.address": "\"Galaxy Hall\" · Mirzo Ulug'bek 8",
  "variant.w04.signoff": "With love, {first} & {second}",

  // ── variant.w03 (Bahor — PhotoLed) ─────────────────────────────────────
  "variant.w03.hero.save_the_date": "save the date",
  "variant.w03.scrap.title": "A new chapter of our lives",
  "variant.w03.scrap.lede": "It will be a great honour to celebrate this day together with you.",
  "variant.w03.story.eyebrow": "our story",
  "variant.w03.story.title": "The day that brought us together",
  "variant.w03.story.body": "The journey wasn't easy, but at every step we supported each other. Now we are delighted to invite you to our most beautiful day.",
  "variant.w03.quote.text": "\"Bukhara — the pearl of the Great Silk Road.\"",
  "variant.w03.quote.eyebrow": "BUKHARA · 21.05.2026",
  "variant.w03.stamp.line1": "BUKHARA",
  "variant.w03.stamp.line2": "2026",
  "variant.w03.schedule.0.time": "16:00",
  "variant.w03.schedule.0.event": "Photoshoot",
  "variant.w03.schedule.1.time": "17:00",
  "variant.w03.schedule.1.event": "Nikoh",
  "variant.w03.schedule.2.time": "18:30",
  "variant.w03.schedule.2.event": "Banquet",
  "variant.w03.schedule.3.time": "21:00",
  "variant.w03.schedule.3.event": "Dancing",
  "variant.w03.map.address": "\"Bahor\" garden",

  // ── variant.n01 (Nikoh Royal — Ceremonial) ─────────────────────────────
  "variant.n01.hero.eyebrow": "BISMILLAHIR ROHMANIR ROHIM",
  "variant.n01.detail.0.label": "Ceremony venue",
  "variant.n01.detail.1.label": "Our mahalla",
  "variant.n01.quran.eyebrow": "THE NOBLE QUR'AN",
  "variant.n01.quran.surah": "Surah Ar-Rum · verse 21",
  "variant.n01.quran.uzbek": "\"And among His signs is that He created for you mates from yourselves, that you may find tranquility in them; and He placed between you affection and mercy.\"",
  "variant.n01.schedule.0.time": "10:00",
  "variant.n01.schedule.0.event": "Nikoh recitation",
  "variant.n01.schedule.1.time": "12:00",
  "variant.n01.schedule.1.event": "Lunch",
  "variant.n01.schedule.2.time": "15:00",
  "variant.n01.schedule.2.event": "Counsel",
  "variant.n01.schedule.3.time": "17:00",
  "variant.n01.schedule.3.event": "Closing du'a",
  "variant.n01.map.address": "Mahalla guzar",
  "variant.n01.rsvp.label": "Our invitation to the ceremony.",
  "variant.n01.blessing.translit": "rabbi zidnii ilman",

  // ── variant.w05 (Oqshom — Minimal) ─────────────────────────────────────
  "variant.w05.meta.label": "OQSHOM  ·  NO. 05",
  "variant.w05.meta.year": "MMXXVI",
  "variant.w05.meta.tagline": "the walled city",
  "variant.w05.meta.country": "UZBEKISTAN",
  "variant.w05.cta.save": "SAVE THE DATE  ·  .ICS",
  "variant.w05.cta.rsvp": "RSVP",
  "variant.w05.invite.mark": "¶ I",
  "variant.w05.invite.copy": "We would like to share the most beautiful day of our lives with you.",
  "variant.w05.schedule.eyebrow": "¶ II  ·  PROGRAM",
  "variant.w05.schedule.title_1": "Order",
  "variant.w05.schedule.title_2": "of the day.",
  "variant.w05.schedule.0.num": "01",
  "variant.w05.schedule.0.time": "17:00",
  "variant.w05.schedule.0.event": "Nikoh ceremony",
  "variant.w05.schedule.1.num": "02",
  "variant.w05.schedule.1.time": "18:00",
  "variant.w05.schedule.1.event": "Dinner",
  "variant.w05.schedule.2.num": "03",
  "variant.w05.schedule.2.time": "19:30",
  "variant.w05.schedule.2.event": "Toasts",
  "variant.w05.schedule.3.num": "04",
  "variant.w05.schedule.3.time": "20:00",
  "variant.w05.schedule.3.event": "Dancing",
  "variant.w05.colophon.title": "COLOPHON",
  "variant.w05.colophon.set_label": "SET",
  "variant.w05.colophon.set_value": "BODONI MODA",
  "variant.w05.colophon.accent_label": "ACCENT",
  "variant.w05.colophon.accent_value": "SAGE 7A8268",
  "variant.w05.colophon.paper_label": "PAPER",
  "variant.w05.colophon.paper_value": "CREAM F5EFE6",
  "variant.w05.colophon.place_label": "PLACE",
  "variant.w05.aria.date": "Date {date}",

  // ── variant.b02 (Confetti — Celebration) ───────────────────────────────
  "variant.b02.hero.callout": "happy birthday",
  "variant.b02.hero.yosh": "years old!",
  "variant.b02.cta": "🎉 I'll be at the party!",
  "variant.b02.memories.eyebrow": "memories",
  "variant.b02.memories.title": "The brightest moments",
  "variant.b02.memories.caption.0": "birthday boy!",
  "variant.b02.memories.caption.1": "with friends",
  "variant.b02.memories.caption.2": "cake time",
  "variant.b02.cake.eyebrow": "make a wish",
  "variant.b02.cake.title": "Diyor turns 7!",
  "variant.b02.wishlist.eyebrow": "wishlist",
  "variant.b02.wishlist.title": "Gift ideas",
  "variant.b02.wishlist.0.label": "Lego Star Wars",
  "variant.b02.wishlist.0.price": "220,000 sum",
  "variant.b02.wishlist.1.label": "Bicycle",
  "variant.b02.wishlist.1.price": "450,000 sum",
  "variant.b02.wishlist.2.label": "Book set",
  "variant.b02.wishlist.2.price": "85,000 sum",
  "variant.b02.wishlist.3.label": "Paint set",
  "variant.b02.wishlist.3.price": "45,000 sum",
  "variant.b02.wishlist.claim": "CLAIM",
  "variant.b02.wishlist.claimed": "✓ CLAIMED!",
  "variant.b02.rsvp.label": "We'll see you at the party!",

  // ── variant.bs01 (Beshik — Newborn) ────────────────────────────────────
  "variant.bs01.hero.welcome_stamp": "WELCOME, AMIR",
  "variant.bs01.hero.script": "welcome little one",
  "variant.bs01.hero.alla": "\"Alla, alla, my dear baby, my little one, alla…\"",
  "variant.bs01.hero.body": "A new member has joined our family. We invite you to our beshik to'y ceremony.",
  "variant.bs01.hero.datebox_eyebrow": "BESHIK TO'YI",
  "variant.bs01.story.eyebrow": "our blessing",
  "variant.bs01.story.title": "New life, new joy",
  "variant.bs01.story.body": "With the arrival of our beloved child, we invite you to share in our joy. Beshik to'y is one of the most beautiful parts of our traditions.",
  "variant.bs01.triptych.eyebrow": "tiny moments",
  "variant.bs01.triptych.title": "First days",
  "variant.bs01.triptych.caption.0": "first day",
  "variant.bs01.triptych.caption.1": "month one",
  "variant.bs01.triptych.caption.2": "month two",
  "variant.bs01.rsvp.label": "We'll see you at the celebration.",

  // ── variant.c01 (Forum — Agenda) ───────────────────────────────────────
  "variant.c01.hero.vol": "VOL.01 — ANNUAL EDITION",
  "variant.c01.hero.label": "// 01 — INVITATION",
  "variant.c01.hero.venue_suffix": "HYATT REGENCY",
  "variant.c01.hero.stat.date": "DATE",
  "variant.c01.hero.stat.time": "TIME",
  "variant.c01.hero.stat.venue": "VENUE",
  "variant.c01.hero.stat.dress": "DRESS",
  "variant.c01.hero.stat.dress_value": "BLACK TIE",
  "variant.c01.ticker.0": "ANNUAL CORPORATE GALA",
  "variant.c01.ticker.1": "TASHKENT",
  "variant.c01.ticker.2": "HYATT REGENCY",
  "variant.c01.ticker.3": "BLACK TIE",
  "variant.c01.ticker.4": "RSVP REQUIRED",
  "variant.c01.ticker.5": "VOL.01",
  "variant.c01.ticker.6": "PREMIUM TIER",
  "variant.c01.agenda.label": "AGENDA",
  "variant.c01.agenda.head_time": "TIME",
  "variant.c01.agenda.head_session": "SESSION",
  "variant.c01.agenda.head_duration": "DURATION",
  "variant.c01.agenda.min_suffix": "MIN",
  "variant.c01.agenda.details": "+ details",
  "variant.c01.agenda.0.title": "Welcome reception",
  "variant.c01.agenda.0.sub": "Foyer · Light refreshments",
  "variant.c01.agenda.0.detail": "Cocktails and canapés in the Hyatt Regency foyer. Press lounge available adjacent to the main hall.",
  "variant.c01.agenda.1.title": "Opening keynote",
  "variant.c01.agenda.1.sub": "Main hall · CEO address",
  "variant.c01.agenda.1.detail": "Year in review and strategic outlook. Live captioning provided. Photography permitted from designated areas only.",
  "variant.c01.agenda.2.title": "Awards ceremony",
  "variant.c01.agenda.2.sub": "Recognition of outstanding work",
  "variant.c01.agenda.2.detail": "Presentation of annual awards across leadership, craft, and team excellence categories.",
  "variant.c01.agenda.3.title": "Dinner",
  "variant.c01.agenda.3.sub": "Three-course menu",
  "variant.c01.agenda.3.detail": "Curated three-course menu by the Hyatt culinary team. Dietary preferences confirmed at RSVP.",
  "variant.c01.agenda.4.title": "Live band",
  "variant.c01.agenda.4.sub": "Until late",
  "variant.c01.agenda.4.detail": "Live performance and dancing. Late carriages can be arranged with the concierge desk.",
  "variant.c01.speakers.label": "SPEAKERS",
  "variant.c01.speakers.0.role": "CEO",
  "variant.c01.speakers.1.role": "CMO",
  "variant.c01.speakers.2.role": "CTO",
  "variant.c01.dress.label": "DRESS CODE",
  "variant.c01.dress.title": "BLACK TIE",
  "variant.c01.dress.body": "Strict black tie — formal evening wear required. Tuxedo or dinner jacket with bow tie for gentlemen; floor-length evening gown or cocktail dress for ladies. No exceptions at the door.",
  "variant.c01.dress.palette_label": "PERMITTED PALETTE",
  "variant.c01.dress.swatch.0": "BLACK",
  "variant.c01.dress.swatch.1": "WHITE",
  "variant.c01.dress.swatch.2": "IVORY",
  "variant.c01.dress.swatch.3": "GOLD ACCENT",
  "variant.c01.venue.label": "VENUE",
  "variant.c01.rsvp.label": "RSVP",
  "variant.c01.rsvp.confirm": "Confirm attendance.",
  "variant.c01.share.label": "SHARE",
  "variant.c01.tier": "FORUM PREMIUM",
  "variant.c01.map.address": "Hyatt Regency · Conference Hall A",

  // ── variant.m01 (Tinch — Memorial) ─────────────────────────────────────
  "variant.m01.mourning.translit": "Innaa lillaahi va innaa ilayhi rojiun",
  "variant.m01.hero.eyebrow": "IN LOVING MEMORY",
  "variant.m01.hero.body": "In remembrance of our dear father, grandfather, and friend, we invite you to the memorial ceremony. Please come and pray with our family.",
  "variant.m01.marosim.label": "CEREMONY",
  "variant.m01.recitation.translit": "\"Innaa lillaahi va innaa ilayhi rojiun\"",
  "variant.m01.recitation.meaning": "Indeed, we belong to Allah, and to Him we shall return.",
  "variant.m01.dua.label": "PRAYER & SUPPORT",
  "variant.m01.dua.line": "Recite a du'a in memory of the departed and offer spiritual support to the family.",
  "variant.m01.dua.sub": "In place of flowers — a Fatiha, a prayer. That is the most precious gift you can bring the family.",
  "variant.m01.ledger.label": "MEMORY BOOK",
  "variant.m01.ledger.title": "Leave a memory",
  "variant.m01.ledger.thanks": "Thank you for your memory.",
  "variant.m01.ledger.name_placeholder": "Your name",
  "variant.m01.ledger.line_placeholder": "A few words of memory or a prayer…",
  "variant.m01.ledger.submit": "LEAVE",
  "variant.m01.map.address": "Home of the departed",
  "variant.m01.photo_aria": "Photograph of {names}",

  // ── variant.w06 (Sumalak — Botanical) ──────────────────────────────────
  "variant.w06.hero.tagline": "Spring is renewal, sumalak is love. Welcome to our wedding.",
  "variant.w06.story.eyebrow": "love story",
  "variant.w06.story.title": "A spring that began before Registan",
  "variant.w06.story.body": "Our paths crossed in Samarkand, beneath the golden light of Registan Square. The day Gulnora gazed up at the flowering domes of the Sher-Dor madrasa, Jamshid stood beside her and saw that ancient sight with new eyes for the first time. The walks through the courtyards of Bibi-Khanym, the first flatbreads and sweets from Siyob bazaar, and the sumalak we cooked together on the eve of Navruz — all of it brought us to this day. Spring has returned, the trees are in bloom, and we welcome you to our wedding in the city we love most.",
  "variant.w06.navruz.eyebrow": "NAVRUZ · A SPRING TRADITION",
  "variant.w06.navruz.title": "Sumalak — the sweet promise of spring",
  "variant.w06.navruz.body": "On the eve of Navruz, women spend the night around the cauldron, stirring sumalak from sprouted wheat — ninety-six hours of springtime ritual with a wooden paddle. Good intentions simmer and turn golden: blessing, health, and the first sweetness of new life.",
  "variant.w06.navruz.proverb": "\"May the sumalak set, and may your happiness multiply.\"",
  "variant.w06.navruz.badge_0_label": "Wheat sprouts",
  "variant.w06.navruz.badge_0_sub": "spring",
  "variant.w06.navruz.badge_1_label": "Pomegranate",
  "variant.w06.navruz.badge_1_sub": "light and blessing",
  "variant.w06.navruz.badge_2_label": "Saffron",
  "variant.w06.navruz.badge_2_sub": "sunlight",
  "variant.w06.schedule.0.event": "Navruz osh — sharing sumalak",
  "variant.w06.schedule.1.event": "Nikoh ceremony",
  "variant.w06.schedule.2.event": "Celebratory lunch",
  "variant.w06.schedule.3.event": "Photoshoot at Registan",
  "variant.w06.schedule.4.event": "Banquet and music",
  "variant.w06.schedule.5.event": "Dancing around the fire",
  "variant.w06.map.address": "Samarkand · Registan Square · 'Karavan-Saray' wedding hall",
  "variant.w06.rsvp.label": "Welcome to spring — our wedding invitation to you",

  // ── variant.w07 (Marvarid — Seaside) ──────────────────────────────────
  "variant.w07.hero.cta": "RSVP",
  "variant.w07.story.eyebrow": "our story",
  "variant.w07.story.title": "A story that began at Charvak",
  "variant.w07.story.body": "Our first meeting was on the Charvak reservoir — a summer evening, in a boat. As Lola gazed at the horizon, Jasur gave her a pair of pearl earrings. Two summers have passed since: chaikhanas, walks along the shore, and a thousand sunsets. Now, beside you, by that same water, it is time to say 'yes' forever.",
  "variant.w07.tide.title": "Charvak tide schedule",
  "variant.w07.tide.subtitle": "We will start the boat parade in the sunlit hours — let the surface of the water join the ceremony.",
  "variant.w07.tide.0.label": "Sunrise",
  "variant.w07.tide.1.label": "High water",
  "variant.w07.tide.2.label": "Boat parade",
  "variant.w07.tide.3.label": "Sunset",
  "variant.w07.schedule.0.event": "Welcoming guests · shoreline",
  "variant.w07.schedule.1.event": "Nikoh ceremony · on the water",
  "variant.w07.schedule.2.event": "Lunch banquet",
  "variant.w07.schedule.3.event": "Boat tour",
  "variant.w07.schedule.4.event": "Starlit banquet",
  "variant.w07.schedule.5.event": "Fire show",
  "variant.w07.map.address": "Charvak · 'Royal Marina' wedding hall · on the water",

  // ── variant.y01 (Yubiley — Jubilee) ───────────────────────────────────
  "variant.y01.story.eyebrow": "our story",
  "variant.y01.story.title": "A home of 25 years",
  "variant.y01.story.body": "Twenty-five years ago, two people set out on a lifelong journey. Madina and Tursun raised three children, heard the laughter of their first grandchild, lit the dastarkhan with treasured friends, and never let go of each other's hand even in the quietest moments. Growing old together is both the greatest gift and the greatest work. Today we honour a quarter-century of that journey, and we wish to celebrate it alongside you, our dearest family.",
  "variant.y01.timeline.title": "Stops along our path",
  "variant.y01.timeline.0.title": "Nikoh",
  "variant.y01.timeline.0.body": "The wedding of Madina and Tursun. It was spring, and the two families came to know each other closely for the first time.",
  "variant.y01.timeline.1.title": "First child",
  "variant.y01.timeline.1.body": "First steps as a family — our eldest daughter was born. The house filled with the laughter of children.",
  "variant.y01.timeline.2.title": "Our own home",
  "variant.y01.timeline.2.body": "After seven years of working together, the keys to our first home in Tashkent landed in our hands.",
  "variant.y01.timeline.3.title": "First grandchild",
  "variant.y01.timeline.3.body": "The titles of grandfather and grandmother. The most awaited gift of our lives — our first grandchild.",
  "variant.y01.timeline.4.title": "Silver wedding",
  "variant.y01.timeline.4.body": "Twenty years together. In the family circle we said 'yes' once again — this time alongside our children.",
  "variant.y01.timeline.5.title": "25th anniversary",
  "variant.y01.timeline.5.body": "A quarter-century together. Today we invite you to celebrate this date with us.",
  "variant.y01.schedule.0.event": "Welcoming guests",
  "variant.y01.schedule.1.event": "Words of honour · from the children",
  "variant.y01.schedule.2.event": "Banquet",
  "variant.y01.schedule.3.event": "First dance · 25 years on",
  "variant.y01.schedule.4.event": "Toasts and gifts",
  "variant.y01.map.address": "Tashkent · 'Heritage Hall' anniversary venue",

  // ── variant.f01 (Fotixa — Engagement) ─────────────────────────────────
  "variant.f01.hero.eyebrow": "FOTIXA-TUY",
  "variant.f01.story.eyebrow": "our family",
  "variant.f01.story.title": "Two families around one dastarkhan",
  "variant.f01.story.body": "Today two families gathered around one dastarkhan. The fathers — Rustam-aka and Bahodir-aka — clasped hands and opened a new chapter of life. The mothers exchanged traditional bread, sweets, and hand-stitched scarves — small gifts that signal closeness and respect. Aziza and Sardor said their 'yes' to each other; and we, both families, invite you to bear witness to these sacred moments.",
  "variant.f01.family.eyebrow": "TWO FAMILIES · ONE TREE",
  "variant.f01.family.title": "Our family tree",
  "variant.f01.family.intro": "Two roots merge into a single trunk and bring forth new branches. The 'yes' Aziza and Sardor spoke to each other is the first blossom of this tree.",
  "variant.f01.family.groom_label": "Groom's side",
  "variant.f01.family.bride_label": "Bride's side",
  "variant.f01.family.groom.0.role": "Father",
  "variant.f01.family.groom.0.name": "Rustam-aka",
  "variant.f01.family.groom.1.role": "Mother",
  "variant.f01.family.groom.1.name": "Mavluda-opa",
  "variant.f01.family.groom.2.role": "Brother",
  "variant.f01.family.groom.2.name": "Jasur",
  "variant.f01.family.bride.0.role": "Father",
  "variant.f01.family.bride.0.name": "Bahodir-aka",
  "variant.f01.family.bride.1.role": "Mother",
  "variant.f01.family.bride.1.name": "Munira-opa",
  "variant.f01.family.bride.2.role": "Sister",
  "variant.f01.family.bride.2.name": "Madina",
  "variant.f01.schedule.0.event": "Arrival of guests from the groom's side",
  "variant.f01.schedule.1.event": "Ceremonial entrance · flowers and bread",
  "variant.f01.schedule.2.event": "Quyma osh",
  "variant.f01.schedule.3.event": "Words from the parents",
  "variant.f01.schedule.4.event": "Exchange of gifts",
  "variant.f01.schedule.5.event": "Closing du'a",
  "variant.f01.map.address": "Tashkent · bride's home · mahalla guzar",
  "variant.f01.rsvp.label": "We humbly ask you to join our family.",

  // ── variant.sn01 (Sunnat — Celebration) ───────────────────────────────
  "variant.sn01.hero.eyebrow": "SUNNAT-TUY · MAHALLA CELEBRATION",
  "variant.sn01.hero.age": "{n} years old",
  "variant.sn01.dua.eyebrow": "DU'A & GOOD PATH",
  "variant.sn01.dua.title": "Our wishes for Behruz",
  "variant.sn01.dua.intro": "Dear relatives and mahalla neighbours — on this day we receive the kindest words you have to offer to our Behruz.",
  "variant.sn01.dua.0": "May Allah's mercy and blessings be upon you",
  "variant.sn01.dua.1": "May you live a healthy and happy life",
  "variant.sn01.dua.2": "May you be the light of your parents' eyes",
  "variant.sn01.dua.3": "May your path always be bright",
  "variant.sn01.dua.amen": "ameen",
  "variant.sn01.schedule.0.event": "Welcoming guests · chaikhana",
  "variant.sn01.schedule.1.event": "Sunnat ceremony",
  "variant.sn01.schedule.2.event": "Quyma palov",
  "variant.sn01.schedule.3.event": "Games for the children",
  "variant.sn01.schedule.4.event": "Concert and tributes",
  "variant.sn01.schedule.5.event": "Presentation of gifts",
  "variant.sn01.map.address": "Tashkent · 'Bahor' chaikhana · mahalla guzar",
  "variant.sn01.rsvp.label": "Bring joy to our celebration",

  // ── variant.g01 (Bitiruv — Academia) ──────────────────────────────────
  "variant.g01.hero.eyebrow": "GRADUATION CEREMONY",
  "variant.g01.hero.institution": "UNIVERSITY OF INFORMATION TECHNOLOGIES",
  "variant.g01.story.eyebrow": "academic journey",
  "variant.g01.story.title": "Four years of work",
  "variant.g01.story.body": "In August 2022, Sevinch entered TUIT's Faculty of Computer Engineering — Software Engineering track. For four years she spent her evenings at her computer studying algorithms, databases, machine learning and natural language processing. First year: a small compiler in C++. Second year: a web platform that won a team hackathon. Third year: an internship at IT Park. Now her diploma project — a modern AI model for the Uzbek language — is being presented. Four years of work, thousands of lines of code, countless cups of coffee — and today, in academic dress with a gold medal in hand, Sevinch delivers her speech at the graduation ceremony.",
  "variant.g01.achievements.eyebrow": "ACADEMIC RECORD",
  "variant.g01.achievements.title": "Achievements",
  "variant.g01.achievements.0.label": "GPA 3.92 / 4.00",
  "variant.g01.achievements.0.detail": "Magna cum laude — top 5% of the faculty",
  "variant.g01.achievements.1.label": "Hackathon · 2nd place",
  "variant.g01.achievements.1.detail": "TUIT × IT Park · Spring 2024",
  "variant.g01.achievements.2.label": "Diploma project",
  "variant.g01.achievements.2.detail": "AI for Uzbek language — transformer-based models",
  "variant.g01.achievements.3.label": "Magna Cum Laude",
  "variant.g01.achievements.3.detail": "Academic distinction · honours diploma",
  "variant.g01.achievements.4.label": "Student council chair",
  "variant.g01.achievements.4.detail": "2024 – 2026 · two terms",
  "variant.g01.schedule.0.event": "Welcoming guests · TUIT main hall",
  "variant.g01.schedule.1.event": "Graduation ceremony",
  "variant.g01.schedule.2.event": "Diploma presentation",
  "variant.g01.schedule.3.event": "Celebratory lunch",
  "variant.g01.schedule.4.event": "Photo session",
  "variant.g01.schedule.5.event": "Graduation dinner · with family",
  "variant.g01.map.address": "TUIT · Tashkent · Amir Temur street 108",
  "variant.g01.rsvp.label": "Make Sevinch's day",

  // ── variant.b03 (Bayramcha — Adult Birthday) ──────────────────────────
  "variant.b03.hero.eyebrow": "30 YEARS · TURNS THIRTY",
  "variant.b03.hero.age_label": "a thirty-year celebration",
  "variant.b03.story.eyebrow": "a year",
  "variant.b03.story.title": "A new decade",
  "variant.b03.story.body": "Thirty — the moment to close one decade and open the next. Tonight I want to see beside me my dearest friends, my beloved family and the people who have given me every reason to smile. You are my greatest wealth. Let us raise a glass together and step into the next decade with a calm and grateful heart.",
  "variant.b03.cocktails.eyebrow": "SIGNATURE COCKTAILS",
  "variant.b03.cocktails.title": "Cocktail menu",
  "variant.b03.cocktails.outro": "…and of course, real champagne — the heart of the night.",
  "variant.b03.cocktails.0.name": "Nodira's Spritz",
  "variant.b03.cocktails.0.recipe": "prosecco · aperol · orange",
  "variant.b03.cocktails.1.name": "Charvak Sour",
  "variant.b03.cocktails.1.recipe": "whisky · honey · lemon",
  "variant.b03.cocktails.2.name": "Bahor Royale",
  "variant.b03.cocktails.2.recipe": "champagne · pear",
  "variant.b03.schedule.0.event": "Welcoming guests",
  "variant.b03.schedule.1.event": "Champagne pop",
  "variant.b03.schedule.2.event": "Banquet",
  "variant.b03.schedule.3.event": "Cake cutting",
  "variant.b03.schedule.4.event": "Dance floor",
  "variant.b03.schedule.5.event": "After-party",
  "variant.b03.map.address": "Tashkent · 'Mascarpone Lounge' · Mustaqillik street",
  "variant.b03.rsvp.label": "We'll be expecting you",

  // ── variant.c02 (Studio — Launch Event) ───────────────────────────────
  "variant.c02.story.title": "// about",
  "variant.c02.story.body": "We're building a startup out of Tashkent — and we're shipping our first real product to the world. At PRODUCT × LAUNCH we debut a new software platform: built in Uzbekistan, designed for the region, engineered for global scale. Founders, engineers, designers and investors all in one room — to demo what we built, to share why now, and to show who's behind the work. Come for the live demo, stay for the panel. Code talks, hype walks. v1.0 ships tonight.",
  "variant.c02.roadmap.intro": "// what we're shipping. 0 → 1 in 12 months.",
  "variant.c02.roadmap.0.quarter": "2026 Q4",
  "variant.c02.roadmap.0.title": "Launch · v1.0",
  "variant.c02.roadmap.1.quarter": "2027 Q1",
  "variant.c02.roadmap.1.title": "Mobile apps · iOS + Android",
  "variant.c02.roadmap.2.quarter": "2027 Q2",
  "variant.c02.roadmap.2.title": "Open API",
  "variant.c02.roadmap.3.quarter": "2027 Q3",
  "variant.c02.roadmap.3.title": "Series A",
  "variant.c02.schedule.0.event": "Doors · check-in",
  "variant.c02.schedule.1.event": "Welcome talk",
  "variant.c02.schedule.2.event": "Live demo",
  "variant.c02.schedule.3.event": "Panel discussion",
  "variant.c02.schedule.4.event": "Networking",
  "variant.c02.schedule.5.event": "After-party",
  "variant.c02.map.address": "Tashkent · IT Park · Conference hall",
  "variant.c02.hero.doors": "doors 19:00 · check-in opens",

  // ── variant.m02 (Yodgorlik — Reverent) ────────────────────────────────
  "variant.m02.hero.translit": "Innaa lillaahi va innaa ilayhi rojiun",
  "variant.m02.hero.uz_meaning": "\"Indeed, we belong to Allah, and to Him we shall return.\" With deep respect, we invite you to the memorial ceremony for our beloved father and grandfather, Olim Yusupov.",
  "variant.m02.hero.marosim_label": "CEREMONY",
  "variant.m02.story.eyebrow": "life and legacy",
  "variant.m02.story.title": "In memory of Olim Yusupov",
  "variant.m02.story.body": "Olim Yusupov was born in Bukhara in 1942. He spent forty years of his life teaching Arabic and the science of hadith at the Mir-i-Arab madrasa — quiet, humble, but a teacher remembered by every one of his students. Together with his wife Sa'odat-opa he raised three children and was blessed to see five grandchildren. Walking through the gardens of the old city, reciting the Qur'an, and watching the family gather around the dastarkhan — these were his greatest joys. He has left us in body, but his words, his patience and his prayers continue to live in every corner of our home.",
  "variant.m02.verses.eyebrow": "VERSES OF THE QUR'AN",
  "variant.m02.verses.title": "For the soul of the departed",
  "variant.m02.verses.0.uzbek": "Indeed, we belong to Allah, and to Him we shall return.",
  "variant.m02.verses.0.reference": "AL-BAQARAH · 2:156",
  "variant.m02.verses.1.uzbek": "Every soul shall taste death; and on the Day of Resurrection you will be paid your reward in full.",
  "variant.m02.verses.1.reference": "ALI 'IMRAN · 3:185",
  "variant.m02.verses.2.uzbek": "O tranquil soul! Return to your Lord, well-pleased and well-pleasing.",
  "variant.m02.verses.2.reference": "AL-FAJR · 89:27–28",
  "variant.m02.tributes.eyebrow": "WORDS FROM THE FAMILY",
  "variant.m02.tributes.title": "In the memory of those closest",
  "variant.m02.tributes.0.relation": "Wife",
  "variant.m02.tributes.0.name": "Sa'odat-opa",
  "variant.m02.tributes.0.text": "Olim-aka — for forty years he never let us down on the most joyful or the hardest days of our lives. In silence and in laughter, he was our foundation.",
  "variant.m02.tributes.1.relation": "Son",
  "variant.m02.tributes.1.name": "Sherzod",
  "variant.m02.tributes.1.text": "Father was our greatest teacher. The meaning he gave to his students at the madrasa, we saw at home every day.",
  "variant.m02.tributes.2.relation": "Daughter",
  "variant.m02.tributes.2.name": "Munira",
  "variant.m02.tributes.2.text": "Father was never in a hurry, and he never left anyone behind. Walking the streets of Bukhara together, he taught me to greet every familiar face.",
  "variant.m02.tributes.3.relation": "Granddaughter",
  "variant.m02.tributes.3.name": "Aziza",
  "variant.m02.tributes.3.text": "Grandfather's favourite books still stand on the shelf beside his chair. Now I read them, and it is as though I can hear his voice.",
  "variant.m02.map.address_suffix": "Home of the departed · mahalla guzar",

  // ── variant.r01 (Mehmonxona — Restaurant Opening) ─────────────────────
  "variant.r01.hero.eyebrow": "GRAND OPENING",
  "variant.r01.hero.tagline": "A new Tashkent palov",
  "variant.r01.story.eyebrow": "the opening",
  "variant.r01.story.title": "A new house of palov in Tashkent",
  "variant.r01.story.body": "'Palov & Co' is a new home opening in the heart of Tashkent. Our head chef Bobur Karimov has poured twenty years of experience into a single bowl of palov: hand-picked long-grain rice, mountain fat, and carrots brought from the Fergana Valley. For us, palov is not merely a dish — it is the tradition of gathering around the dastarkhan, of laughter, and of hospitality. We invite you to be the first guests of our new home.",
  "variant.r01.menu.eyebrow": "MENU · OPENING NIGHT",
  "variant.r01.menu.title": "The first dastarkhan",
  "variant.r01.menu.disclaimer": "* The menu is seasonal and may change",
  "variant.r01.menu.0.name": "Tashkent palov",
  "variant.r01.menu.0.note": "",
  "variant.r01.menu.0.price": "65 000 sum",
  "variant.r01.menu.1.name": "Manti",
  "variant.r01.menu.1.note": "hand-folded",
  "variant.r01.menu.1.price": "35 000 sum",
  "variant.r01.menu.2.name": "Lag'mon",
  "variant.r01.menu.2.note": "house-simmered",
  "variant.r01.menu.2.price": "32 000 sum",
  "variant.r01.menu.3.name": "Norin",
  "variant.r01.menu.3.note": "",
  "variant.r01.menu.3.price": "28 000 sum",
  "variant.r01.menu.4.name": "Tea",
  "variant.r01.menu.4.note": "from the samovar",
  "variant.r01.menu.4.price": "8 000 sum",
  "variant.r01.menu.5.name": "Halva",
  "variant.r01.menu.5.note": "house-made",
  "variant.r01.menu.5.price": "18 000 sum",
  "variant.r01.chef.eyebrow": "HEAD CHEF",
  "variant.r01.chef.name": "Bobur Karimov",
  "variant.r01.chef.experience": "20 years of experience",
  "variant.r01.chef.bio": "Born in the Fergana Valley, having worked in celebrated restaurants in Istanbul and Paris — he is now opening his own home in Tashkent. His palov is the harmony of tradition and modern thought.",
  "variant.r01.schedule.0.event": "Welcoming guests · chaikhana spread",
  "variant.r01.schedule.1.event": "Restaurant opening · ribbon cutting",
  "variant.r01.schedule.2.event": "Dinner menu",
  "variant.r01.schedule.3.event": "Words from the head chef",
  "variant.r01.schedule.4.event": "Live music · dombira",
  "variant.r01.schedule.5.event": "After-party",
  "variant.r01.map.address": "Tashkent · Mustaqillik street 47 · 'Palov & Co' restaurant",
  "variant.r01.rsvp.label": "Be our very first guest",

  // ── variant.u01 (Housewarming) ────────────────────────────────────────
  "variant.u01.hero.eyebrow": "HOUSEWARMING · 2026",
  "variant.u01.hero.headline": "The Karimovs invite you to their new home",
  "variant.u01.hero.subtitle": "Let us step over a new threshold together — close family, kind neighbours, and warm conversation around our table await you.",
  "variant.u01.story.eyebrow": "our new home",
  "variant.u01.story.title": "Our very first home",
  "variant.u01.story.body": "The day we long dreamt of has arrived — for the first time we've crossed the threshold of our own home. The walls are fresh, the courtyard is wide, and the doors will always stay open. By the old tradition of our hospitable people, family, relatives, and neighbours visit a new house to offer their blessings. So we invite you — our nearest and dearest — to be the very first guests of our new home. May our bread and salt, our warmth, and our laughter be shared with you.",
  "variant.u01.tour.eyebrow": "A LITTLE TOUR",
  "variant.u01.tour.title": "Four corners of our new home",
  "variant.u01.tour.subtitle": "Every room — a small story. We invite you into each one.",
  "variant.u01.tour.0.name": "Living room",
  "variant.u01.tour.0.note": "A wide table and warm conversation are waiting for you.",
  "variant.u01.tour.1.name": "Kitchen",
  "variant.u01.tour.1.note": "Mother's palov — the most welcoming scent of home.",
  "variant.u01.tour.2.name": "Courtyard",
  "variant.u01.tour.2.note": "Under the mulberry tree we'll share tea and talk.",
  "variant.u01.tour.3.name": "Terrace",
  "variant.u01.tour.3.note": "Evening breeze and the quiet lights of the city.",
  "variant.u01.gifts.eyebrow": "IF YOU WISH",
  "variant.u01.gifts.title": "Housewarming gifts",
  "variant.u01.gifts.subtitle": "By our tradition, useful gifts are brought to a new home. A gift is never an obligation — only a quiet sign of care.",
  "variant.u01.gifts.0.name": "Towel set",
  "variant.u01.gifts.0.price": "120 000 – 180 000 soum",
  "variant.u01.gifts.1.name": "Tea set · piyolas",
  "variant.u01.gifts.1.price": "150 000 – 250 000 soum",
  "variant.u01.gifts.2.name": "House plant (palm, monstera)",
  "variant.u01.gifts.2.price": "200 000 – 400 000 soum",
  "variant.u01.gifts.3.name": "Bed linen · duvet set",
  "variant.u01.gifts.3.price": "180 000 – 350 000 soum",
  "variant.u01.gifts.4.name": "Kitchen knife set",
  "variant.u01.gifts.4.price": "250 000 – 500 000 soum",
  "variant.u01.gifts.disclaimer": "* The best gift of all is your blessing and your laughter.",
  "variant.u01.schedule.0.event": "Welcoming guests · tea and sweets",
  "variant.u01.schedule.1.event": "Opening of the table · palov",
  "variant.u01.schedule.2.event": "Tour of the new home · room by room",
  "variant.u01.schedule.3.event": "Music and dance · family conversation",
  "variant.u01.schedule.4.event": "Closing blessing · words from the elders",
  "variant.u01.map.address": "Tashkent · Yunusobod district · Karimov mahalla · house 14",
  "variant.u01.rsvp.label": "Come to our new home",

  // ── Legal pages ───────────────────────────────────────────────────────
  "legal.updated": "Updated",
  "legal.privacy.title": "Privacy Policy",
  "legal.privacy.h.collect": "What we collect",
  "legal.privacy.collect": "We collect only the minimum data needed to create and deliver invitations:",
  "legal.privacy.collect.phone": "Email address for sign-in.",
  "legal.privacy.collect.event": "Event details you enter (names, date, venue, photos, music).",
  "legal.privacy.collect.guests": "When guests RSVP — name, attendance status, party size, optional message.",
  "legal.privacy.h.use": "How we use your data",
  "legal.privacy.use": "Your data is used only to render the invitation, collect guest responses, and contact you when necessary. We do not sell data to third parties or run advertising on your invitations.",
  "legal.privacy.h.tracking": "Tracking and analytics",
  "legal.privacy.tracking": "taklifla.uz uses no third-party trackers or analytics (no Google Analytics, Facebook Pixel, etc.). Only our own server-side operational logs.",
  "legal.privacy.h.retention": "Data retention",
  "legal.privacy.retention": "Invitations and guest responses are kept for as long as your account exists. If you delete your account, all related data is permanently removed within 30 days.",
  "legal.privacy.h.contact": "Contact",
  "legal.privacy.contact": "For privacy-related questions write to:",

  "legal.terms.title": "Terms of Service",
  "legal.terms.h.service": "About the service",
  "legal.terms.service": "taklifla.uz is a platform for creating and sharing digital invitations. Invitations you publish are shared via a link with the people you choose.",
  "legal.terms.h.tiers": "Free and paid tiers",
  "legal.terms.tiers": "The free tier lets you use the standard templates. Premium templates and advanced features are unlocked by a one-time per-invitation payment.",
  "legal.terms.h.refund": "Refunds",
  "legal.terms.refund": "Accidental purchases are refundable within 7 days of payment, provided the invitation has not yet been published. Just write to us.",
  "legal.terms.h.responsibilities": "Your responsibilities",
  "legal.terms.responsibilities": "You confirm that all content posted on an invitation (names, addresses, photos) is lawful and yours to share.",
  "legal.terms.h.contact": "Contact",
  "legal.terms.contact": "For terms-related questions write to:",

  "doc.title": "taklifla.uz — beautiful digital invitations",
};

export default en;
